<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-6-tablet is-5-desktop is-4-widescreen">
            <form
              class="lm-forms"
            >
              <div class="level lm-level">
                <div class="level-item has-text-centered">
                  <figure class="image is-128x128">
                    <img :src="loadLogo" />
                  </figure>
                </div>
              </div>
              <div class="block">
                <b-field
                  class="lm-label"
                  :label="$t('ForgotPassword.labelForgotPassword')"
                  :type="validateTypeEmail"
                  :message="errorMessageEmail"
                >
                  <b-input
                    v-model.trim="$v.email.$model"
                    type="email"
                    :disabled="loading"
                    @keyup.native.enter="send"
                  />
                </b-field>
                <div class="buttons local-lm-xt-margin">
                  <router-link
                    v-t="'Common.back'"
                    :to="{ name: 'Login' }"
                    class="button lm-default-btn-outline-green lm-btn-side-50"
                  />
                  <b-button
                    v-t="'Common.send'"
                    type="is-success"
                    class="lm-default-btn-green lm-btn-side-50"
                    @click.prevent="send"
                  />
                </div>
              </div>
            </form>
            <div class="has-text-centered local-lm-xt-margin local-lm-no-account-text">
              {{ $t("ForgotPassword.bottomText") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, minLength, email } from 'vuelidate/lib/validators'
import Logo from '@/assets/img/lm_logo.svg'
import { mixin } from '@/mixins'

export default {
  name: 'ForgotPassword',
  mixins: [
    mixin.notifications
  ],
  data () {
    return {
      email: '',
      loading: false
    }
  },
  computed: {
    loadLogo () {
      return Logo
    },
    validateTypeEmail () {
      return !this.$v.email.email
        ? 'is-danger'
        : null
    },
    errorMessageEmail () {
      return !this.$v.email.email
        ? this.$t('Errors.validEmail')
        : null
    }
  },
  methods: {
    async send () {
      this.$v.$touch()
      if (this.$v.$invalid) return false

      this.$store.dispatch('loading/onlyComponent')
      this.loading = true

      const newRequestPassword = await this.$store.dispatch('user/setNewRequestPassword', this.email)
      if (!newRequestPassword.level) {
        this.loading = false
        return this.wrong(this.$t(newRequestPassword.errorText))
      }

      this.sucess(this.$t('ForgotPassword.checkEmail'))
      this.$store.dispatch('loading/fullScreen')
      this.$router.push({ name: 'Login' })
    }
  },
  validations: {
    email: {
      required,
      email,
      minLength: minLength(8)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue